module.exports = __webpack_public_path__ + "static/media/designPatent_30-0995298.bce501cf.png";